export default "__VITE_ASSET__CGy_eOdE__"